import React from 'react';
import { useLocation } from 'react-router-dom';

const stepMap = {
  general: 1,
  stock_locations: 2,
  stock: 3,
  users: 4,
};

interface OnboardingStepProps {}

export default function OnboardingStep({}: OnboardingStepProps) {
  const location = useLocation();

  const match = [...Object.entries(stepMap)].find(e => location.pathname.includes(e[0]));
  const step = match ? match[1] : '?';
  return (
    <p className='text-sm text-gray-600'>
      Step {step} out of {Object.keys(stepMap).length}
    </p>
  );
}
